import React from 'react'
import { LoaderSwitcher, MerchantLocationsLoader } from 'router/Loaders'
import { ManageIntegrations } from 'components/Integrations/Manage'

export const ManageIntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <ManageIntegrations />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
